module.exports = __webpack_public_path__ + "static/media/TW.9374cc29.svg";